import { render, staticRenderFns } from "./salesDonnutsCharts.vue?vue&type=template&id=60ff25ed&"
import script from "./salesDonnutsCharts.vue?vue&type=script&lang=js&"
export * from "./salesDonnutsCharts.vue?vue&type=script&lang=js&"
import style0 from "./salesDonnutsCharts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports